module.exports = "/_next/static/images/c6cafdaea4bffd47357dbaf6f8a9d15b-nubanker-bizarch@2x.jpg";